import { render } from "./detectAlert.vue?vue&type=template&id=7da11d72"
import script from "./detectAlert.vue?vue&type=script&lang=js"
export * from "./detectAlert.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__